export default "__VITE_ASSET__BjzsILx9__"